import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const AverageWorkoutTimes = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const { pageValue: wellnessGoal, setPageValue }: any = useLocalStorage({
        key: LocalStorageKeys[RoutePath.AverageWorkoutTimes],
        defaultValue: '',
    });

    const { pageConfiguration } = useContext(BaseContext);

    const handleClick = (answer: ChoiceType) => {
        saveAnswers({
            key: 'average-workout-times',
            itemQuestion: { question: t('average-workout-times-title'), value: t(answer.value) },
        });

        setPageValue(answer.key);

        pageConfiguration.handleOnPageComplete(answer.value);
    };

    const answers: ChoiceType[] = [
        {
            key: 'not-much',
            value: t('average-workout-times-option-not-much'),
        },
        {
            key: 'thirty',
            value: t('average-workout-times-option-thirty'),
        },
        {
            key: 'fortyfive',
            value: t('average-workout-times-option-fortyfive'),
        },
        {
            key: 'more-fortyfive',
            value: t('average-workout-times-option-more-fortyfive'),
        }
    ];

    return (
        <>
            <Typography variant={TypographyVariants.h1}>{t('average-workout-times-title')}</Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === wellnessGoal}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
